export function scrollTo(targetId: string, options: ScrollIntoViewOptions = {}): void {
  // scroll after dom update
  setTimeout(() => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const defaultOptions: ScrollIntoViewOptions = {
        behavior: "smooth",
        block: "start",
        inline: "nearest",
        ...options,
      };
      targetElement.scrollIntoView(defaultOptions);
    }
  }, 0);
}
